import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { AttestorLog } from '../../interfaces/attestor-logs/attestor-log';
import { AttestorLogForCreation } from '../../interfaces/attestor-logs/attestor-log-for-creation';
import { AttestorLogForUpdate } from '../../interfaces/attestor-logs/attestor-log-for-update';

@Injectable({
    providedIn: 'root'
})
export class AttestorLogRepositoryService {
    protected _baseLink: string;

    constructor(
        @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig,
        private http: HttpClient) {
        this._baseLink = `${config.rootUrl}/Logs/AttestorLogs`;
    }

    private generateHeaders = () => {
        return {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
    };

    public getAttestorLog = (logId: string) => {
        return this.http.get<AttestorLog>(`${this._baseLink}/${logId}`);
    };

    public getAttestorOrderLogs = (orderId: string) => {
        return this.http.get<AttestorLog[]>(`${this._baseLink}/Order/${orderId}`);
    };

    public createAttestorLog = (logForCreation: AttestorLogForCreation) => {
        return this.http.post<AttestorLog>(this._baseLink, logForCreation, this.generateHeaders());
    };

    public updateAttestorLog = (logForUpdate: AttestorLogForUpdate) => {
        return this.http.put<AttestorLog>(this._baseLink, logForUpdate, this.generateHeaders());
    };

    public deleteAttestorLog = (logId: string) => {
        return this.http.delete(`${this._baseLink}/${logId}`);
    };
}